var exports = {
  "kL": "DiscoverySidebar.module__container___X1VMMX",
  "CT": "DiscoverySidebar.module__navList___X1VMMX",
  "pc": "DiscoverySidebar.module__navItem___X1VMMX",
  "HW": "DiscoverySidebar.module__navItemActive___X1VMMX",
  "T1": "DiscoverySidebar.module__navItemDisabled___X1VMMX",
  "wz": "DiscoverySidebar.module__navItemIcon___X1VMMX",
  "hk": "DiscoverySidebar.module__navItemLabel___X1VMMX",
  "WG": "DiscoverySidebar.module__comingSoonBadge___X1VMMX",
};

module.exports = exports;
